export const AUTHOR_TYPE = 'author';
export const ALL_AUTHORS = 'all';